<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      ref="dailyTaskList"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
    <b-modal v-model="isActiveModal"
             :no-close-on-backdrop="true"
             centered title="Confirmation"
             @cancel="closeActiveModal"
             @ok="activeQuiz">
      <form>
        <h3 class="text-black-50">{{ message }}</h3>
      </form>
    </b-modal>
    <b-modal v-model="isDeleteModal"
             :no-close-on-backdrop="true"
             centered title="Delete modal"
             @cancel="closeDeleteModal"
             @ok="removeItem">
      <form>
        <h3 class="text-black-50">Are you sure want to delete?</h3>
      </form>
    </b-modal>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from 'moment'
let id = null

export default {
  name: 'DailyTaskListPage',
  data () {
    return {
      active: true,
      isActiveModal: false,
      isDeleteModal: false,
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            let activeItem

            if (item.active) {
              activeItem = <b-dropdown-item onClick={() => this.showActiveModal(item.id, false)}>Deactivate</b-dropdown-item>
            } else {
              activeItem = <b-dropdown-item onClick={() => this.showActiveModal(item.id, true)}>Activate</b-dropdown-item>
            }
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/daily-task/edit/' + item.id}>Edit</b-dropdown-item>
                {activeItem}
                <b-dropdown-item onClick={() => this.showDeleteModal(item)}>Delete</b-dropdown-item>
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'image',
          columnName: 'Image',
          customizeColumn: true,
          value: item => {
            if (!item.image && item.image.url) return ''
            return <img class="profile-img-sm rounded-circle" style="height: 40px;" src={item.image.url}/>
          }
        },
        {
          columnCode: 'title',
          columnName: 'Title',
          align: 'left',
          value: item => {
            return item.title
          }
        },
        {
          columnCode: 'active',
          columnName: 'Status',
          align: 'left',
          value: item => {
            return item.active ? 'Active' : 'Inactive'
          }
        },
        {
          columnCode: 'type',
          columnName: 'Type',
          align: 'left',
          value: item => {
            return item.type ? item.type === 'SUBSCRIPTION' ? 'Subscription' : item.type === 'PHOTO_UPLOAD' ? 'Photo upload' : '' : ''
          }
        },
        {
          columnCode: 'channelName',
          columnName: 'Channel',
          align: 'left',
          value: item => {
            return item.channelName
          }
        },
        {
          columnCode: 'totalCoin',
          columnName: 'Total Coin',
          align: 'left',
          value: item => {
            return item.totalCoin
          }
        },
        {
          columnCode: 'endDate',
          columnName: 'End Date',
          align: 'left',
          value: item => {
            return item.endDate ? moment(item.endDate).format('YYYY-MM-DD HH:mm') : ''
          }
        },
        {
          columnCode: 'repetition',
          columnName: 'Repetition',
          align: 'left',
          value: item => {
            return item.repetition === 'ONE_TIME' ? 'One time' : item.repetition === 'MANY_TIME' ? 'Many times' : item.repetition
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('daily-task/list', payload)
    },
    addNewButton () {
      return (<router-link class="btn btn-success mr-3" to="/daily-task/add"><div class="icon-plus"></div></router-link>)
    },
    closeDeleteModal () {
      this.id = null
      this.$nextTick(() => {
        this.isDeleteModal = false
      })
    },
    showDeleteModal (item) {
      if (!item.id) {
        this.$toastr.error('Item not found')
      }
      this.id = item.id
      this.isDeleteModal = true
    },
    removeItem () {
      if (!this.id) {
        return
      }
      this.$loading.show(true)
      this.axios.delete('daily-task/item', {params: {id: this.id}})
        .then((result) => {
          this.$refs.dailyTaskList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            this.$toastr.success('successfully deleted')
          }
          this.isDeleteModal = false
        })
    },
    showActiveModal (itemId, isActive) {
      if (!itemId) {
        this.$toastr.error('Item not found')
      }
      id = itemId
      this.active = isActive
      this.isActiveModal = true
    },
    closeActiveModal () {
      id = null
      this.active = true
      this.isActiveModal = false
    },
    activeQuiz () {
      if (!id) {
        return
      }
      this.$loading.show()
      this.axios.put('daily-task/active', {id: id, active: this.active})
        .then((result) => {
          this.$refs.dailyTaskList.doRequest()
          this.$loading.hide()
          if (result && result.data && result.data.status === 200) {
            this.$toastr.success('Quiz successfully activated')
          }
          this.isActiveModal = false
          id = null
        })
    }
  },
  computed: {
    message () {
      return this.active ? 'Do you really want to activate' : 'Do you really want to deactivate'
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/task/DailyTaskListPage.vue